export const ABOUT_TIMELINE = [
  { year: '2023', titleKey: 'timeline3Title', descKey: 'timeline3Desc' },
  { year: '2024', titleKey: 'timeline4Title', descKey: 'timeline4Desc' },
  { year: 'Today', titleKey: 'timeline5Title', descKey: 'timeline5Desc' },
];

export const ABOUT_COUNTERS = [
  { value: 55, labelKey: 'counterProjects', showPlus: true },
  { value: 700, labelKey: 'counterEmployees', showPlus: true },
  { value: 38, labelKey: 'counterClients', showPlus: true },
  { value: 3, labelKey: 'counterYears', showPlus: false },
];

export const ABOUT_OPPORTUNITIES = [
  {
    icon: 'fa-line-chart',
    titleKey: 'investTitle',
    descKey: 'investDesc',
    ctaKey: 'investCta',
    ctaHref: '/contact',
    accent: 'gold',
  },
  {
    icon: 'fa-handshake-o',
    titleKey: 'partnerTitle',
    descKey: 'partnerDesc',
    ctaKey: 'partnerCta',
    ctaHref: '/contact',
    accent: 'teal',
  },
  {
    icon: 'fa-users',
    titleKey: 'careersTitle',
    descKey: 'careersDesc',
    ctaKey: 'careersCta',
    ctaHref: '/contact',
    accent: 'dark',
  },
];

export const ABOUT_BENEFITS = [
  { icon: 'fa-shield', titleKey: 'benefit1Title', descKey: 'benefit1Desc' },
  { icon: 'fa-map-marker', titleKey: 'benefit2Title', descKey: 'benefit2Desc' },
  { icon: 'fa-certificate', titleKey: 'benefit3Title', descKey: 'benefit3Desc' },
  { icon: 'fa-industry', titleKey: 'benefit4Title', descKey: 'benefit4Desc' },
  { icon: 'fa-leaf', titleKey: 'benefit5Title', descKey: 'benefit5Desc' },
  { icon: 'fa-clock-o', titleKey: 'benefit6Title', descKey: 'benefit6Desc' },
];

export const ABOUT_PAGE = {
  pageTitle: 'About Us',
  heroLine1: 'Quality Technologies Contracting (Q-Tech)',
  heroLine2: 'Established in 2023 under Al Dawood Holding Group.',
  breadcrumbHome: 'Home',
  breadcrumbAbout: 'About',
  whoWeAre: 'Who We Are',
  groupTitle: 'Q-Tech Contracting',
  intro1Before:
    'Established in 2023, Quality Technologies Contracting (Q-Tech) operates under the Al Dawood Holding Group — a Saudi based construction and trading group founded in 1998, with offices in Al Khobar, Jubail, and Yanbu. Together with companies such as',
  intro1After:
    ', we serve the Eastern and Western regions across the Kingdom of Saudi Arabia.',
  intro2:
    'We have built a strong reputation for delivering high-quality projects in the private and government sectors. Our experienced teams take on sensitive and challenging work — fast-track programs, occupied sites, public areas, and limited access — with a flexible, cooperative, and client-focused approach.',
  quoteTitle: 'Our Vision & Values',
  quote:
    'We firmly believe it is not just about what you deliver, but the way in which you deliver it that really counts. These values set us aside from the many other contractors claiming to deliver quality projects.',
  check1: 'Building & industrial construction',
  check2: 'Civil, mechanical & electrical works',
  check3: 'Private & government sector projects',
  knowMore: 'Explore Our Services',
  chairmanName: 'Engr. Fahad Al Dawood',
  chairmanRole: 'Board Chairman, Al Dawood Holding Group',

  statsSub: 'By The Numbers',
  statsTitleLine1: 'Growing fast since 2023',
  statsTitleLine2: 'across the Kingdom',
  statsDesc:
    'Founded in 2023, Q-Tech has quickly mobilized skilled teams to deliver civil, mechanical, and E&I projects for government and private clients across Saudi Arabia — backed by the experience of Al Dawood Holding Group.',
  contactNow: 'Contact Us',
  counterProjects: 'Projects',
  counterEmployees: 'Total Employees',
  counterClients: 'Clients',
  counterYears: 'Years in Operation',

  mvvSub: 'What Drives Us',
  mvvTitle: 'Mission, Vision & Core Values',
  missionTitle: 'Our Mission',
  missionDesc:
    'To deliver safe, high-quality construction and contracting services that exceed client expectations — on time, within scope, and in full compliance with Saudi regulations.',
  visionTitle: 'Our Vision',
  visionDesc:
    'To be the most trusted construction partner in the Eastern and Western regions of Saudi Arabia, contributing to Vision 2030 through sustainable infrastructure and industrial growth.',
  valuesTitle: 'Our Values',
  valuesDesc:
    'Integrity, safety-first culture, transparent communication, and a relentless commitment to craftsmanship in every project we undertake.',

  journeySub: 'Our Journey',
  journeyTitle: 'Building Saudi Arabia since 2023',
  journeyDesc:
    'Q-Tech was founded in 2023 under Al Dawood Holding Group to deliver integrated construction and contracting services across the Eastern and Western regions of the Kingdom.',
  timeline3Title: 'Q-Tech Contracting established',
  timeline3Desc:
    'Quality Technologies Contracting (Q-Tech) was founded in 2023 to deliver integrated civil, mechanical, and E&I works for private and government clients across Saudi Arabia.',
  timeline4Title: 'Project delivery & growth',
  timeline4Desc:
    'Mobilized teams across Al Khobar, Jubail, and Yanbu — executing industrial, civil, and infrastructure projects for government and private sector clients.',
  timeline5Title: 'Growing together',
  timeline5Desc:
    'Today we partner with leading clients, investors, and subcontractors — building the future of Saudi Arabia.',

  opportunitiesSub: 'Grow With Us',
  opportunitiesTitle: 'Invest, partner, or build your career with us',
  opportunitiesDesc:
    'Whether you are an investor seeking strategic opportunities, a company looking for a reliable joint-venture partner, or a professional ready to grow — we welcome the conversation.',

  investTitle: 'Invest With Us',
  investDesc:
    'Partner with a Saudi-owned group positioned for long-term growth in construction, industrial development, and infrastructure aligned with Vision 2030.',
  investCta: 'Discuss Investment',
  partnerTitle: 'Partner With Us',
  partnerDesc:
    'Join forces on mega-projects through joint ventures, alliance agreements, and subcontracting partnerships across civil, mechanical, and E&I disciplines.',
  partnerCta: 'Start a Partnership',
  careersTitle: 'Work With Us',
  careersDesc:
    'Build your career with Q-Tech — join engineers, supervisors, and field professionals delivering landmark projects across Saudi Arabia. We invest in training, safety, and career progression.',
  careersCta: 'View Opportunities',

  whyPartnerSub: 'Why Q-Tech',
  whyPartnerTitle: 'What sets us apart as a partner',
  benefit1Title: 'Saudi-owned & established',
  benefit1Desc:
    'Established in 2023 and backed by Al Dawood Holding Group — with nearly 30 years of group track record and deep relationships across government and private sectors.',
  benefit2Title: 'Multi-region presence',
  benefit2Desc: 'Offices in Al Khobar, Jubail, and Yanbu — positioned to mobilize quickly on Eastern and Western Province projects.',
  benefit3Title: 'Certified & compliant',
  benefit3Desc: 'Full adherence to Saudi building codes, HSE standards, and client-specific quality systems on every site.',
  benefit4Title: 'Integrated capabilities',
  benefit4Desc: 'Civil, mechanical, electrical, and instrumentation under one roof — reducing coordination risk on complex programmes.',
  benefit5Title: 'Sustainability focus',
  benefit5Desc: 'Modern methods, waste reduction, and energy-efficient practices aligned with national sustainability goals.',
  benefit6Title: 'On-time delivery',
  benefit6Desc: 'Proven fast-track execution on occupied sites, limited-access areas, and time-critical industrial programmes.',

  skillsTitle: 'Our management skills and work experience',
  skillsDesc:
    'Backed by Al Dawood Holding Group, our teams bring strong combined experience across planning, design, execution, and delivery — ensuring every project meets Saudi standards and client expectations.',
  skillPlanning: 'Planning',
  skillDesign: 'Design',
  skillDevelopment: 'Development',
  skillDelivery: 'Delivery',

  teamSub: 'Our Leadership',
  teamTitle: 'Meet the people behind our projects',

  letsTalk: 'Lets talk',
  projectQuestion: 'Have an upcoming project?',
  placeholderName: 'Name',
  placeholderEmail: 'E-Mail',
  placeholderPhone: 'Phone Number',
  placeholderService: 'Select related service',
  placeholderOther: 'Other',
  placeholderMessage: 'Your Message Here',
  submitNow: 'Submit Now',
  officeTitle: 'Al Khobar Office',
  emailUs: 'Email us',
  callUs: 'Call us',
  workWithUs: 'Ready to collaborate?',
  ctaTitle: "Let's build something great together",
  ctaDesc:
    'Reach out to discuss investment opportunities, project partnerships, or your next construction programme across Saudi Arabia.',
  getStarted: 'Get In Touch',
};
